import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
const traps = [{
  title: 'Cambiar "de golpe"',
  result: 'Intestino no se adapta → diarrea → pánico → retroceso',
  icon: AlertTriangle,
  color: 'text-amber'
}, {
  title: 'Seguir recetas virales',
  result: 'No tienen porciones ni ajuste por señales individuales',
  icon: XCircle,
  color: 'text-red'
}, {
  title: 'Meter muchos toppings',
  result: 'Demasiadas variables → caos digestivo inmediato',
  icon: XCircle,
  color: 'text-red'
}, {
  title: 'Comprar "súper premium"',
  result: 'Sigue siendo ultraprocesado; no resuelve la duda real',
  icon: XCircle,
  color: 'text-red'
}, {
  title: 'BARF avanzado de entrada',
  result: 'Se siente caro y técnico → abandono rápido',
  icon: XCircle,
  color: 'text-red'
}];
export function TrapSection() {
  return <Section className="bg-stone-50" data-id="element-148">
      <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-149">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-150">
          La trampa
        </h2>
        <p className="text-xl text-navy/80" data-id="element-151">
          La trampa no es la comida real.{' '}
          <span className="font-bold text-red" data-id="element-152">La trampa es improvisar.</span>
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-153">
        {traps.map((trap, index) => <Card key={index} delay={index * 0.1} className="border-l-4 border-l-red hover:shadow-lg transition-shadow" data-id="element-154">
            <div className="flex items-start gap-4" data-id="element-155">
              <trap.icon className={`h-6 w-6 flex-shrink-0 mt-1 ${trap.color}`} data-id="element-156" />
              <div data-id="element-157">
                <h3 className="font-bold text-navy text-lg mb-2" data-id="element-158">
                  {trap.title}
                </h3>
                <p className="text-navy/70 text-sm leading-relaxed" data-id="element-159">
                  {trap.result}
                </p>
              </div>
            </div>
          </Card>)}
      </div>

      <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-160">
        <p className="text-lg text-navy/80 italic" data-id="element-161">
          "Y cuando algo sale mal… haces lo lógico: vuelves a lo conocido.
          Croqueta otra vez. Culpa otra vez."
        </p>
      </div>
    </Section>;
}